/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const FabBaseSizeDesktopMedium = '56px'
export const FabBaseSizeDesktopSmall = '40px'
export const FabBaseSizeMobileMedium = '56px'
export const FabBaseSizeMobileSmall = '40px'
export const FabBaseBorderRadiusDesktopMedium = '28px'
export const FabBaseBorderRadiusDesktopSmall = '20px'
export const FabBaseBorderRadiusMobileMedium = '28px'
export const FabBaseBorderRadiusMobileSmall = '20px'
export const FabBaseSpacingLabelOnDesktopSmallLeft = '8px'
export const FabBaseSpacingLabelOnDesktopSmallRight = '16px'
export const FabBaseSpacingLabelOnDesktopSmallGap = '8px'
export const FabBaseSpacingLabelOnDesktopMediumLeft = '16px'
export const FabBaseSpacingLabelOnDesktopMediumRight = '24px'
export const FabBaseSpacingLabelOnDesktopMediumGap = '16px'
export const FabBaseSpacingLabelOnMobileSmallLeft = '8px'
export const FabBaseSpacingLabelOnMobileSmallRight = '16px'
export const FabBaseSpacingLabelOnMobileSmallGap = '8px'
export const FabBaseSpacingLabelOnMobileMediumLeft = '16px'
export const FabBaseSpacingLabelOnMobileMediumRight = '24px'
export const FabBaseSpacingLabelOnMobileMediumGap = '16px'
export const FabBaseSpacingLabelOffDesktopSmallLeft = '8px'
export const FabBaseSpacingLabelOffDesktopSmallRight = '8px'
export const FabBaseSpacingLabelOffDesktopMediumLeft = '16px'
export const FabBaseSpacingLabelOffDesktopMediumRight = '16px'
export const FabBaseSpacingLabelOffMobileSmallLeft = '8px'
export const FabBaseSpacingLabelOffMobileSmallRight = '8px'
export const FabBaseSpacingLabelOffMobileMediumLeft = '16px'
export const FabBaseSpacingLabelOffMobileMediumRight = '16px'
